import { Tooltip } from 'react-tooltip';
import InfoCircle from 'svg/InfoCircle';
import { InfoRowProps } from './props';

const InfoRow: React.FC<InfoRowProps> = ({ label, value, tooltipId, tooltipContent }) => (
  <div className="flex justify-between gap-1">
    <div className="flex items-center gap-2">
      <span>{label}</span>
      {tooltipId && tooltipContent && (
        <>
          <InfoCircle
            className="h-4 w-4 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon"
            data-tooltip-id={tooltipId}
          />
          <Tooltip id={tooltipId} content={tooltipContent} place="bottom" />
        </>
      )}
    </div>
    <span>{value}</span>
  </div>
);

export default InfoRow;
